<template>
  <div class="qualitychecktest-list">
    <Toolbar :handle-add="addHandler" v-if="userHasAccess('qualitychecktest_edit')"/>

    <v-container grid-list-xl fluid>
      <v-layout row wrap>
        <v-flex sm12>
          <h1><v-icon large>mdi-bug-check</v-icon>{{$t('qualitycheck.test.tests')}}</h1>
        </v-flex>
        <v-flex lg12>
          <DataFilter :handle-filter="onSendFilter" :handle-reset="resetFilter">
            <QualityCheckTestFilterForm
              ref="filterForm"
              :values="filters"
              slot="filter"
            />
          </DataFilter>

          <br />

          <v-data-table
            v-model="selected"
            :headers="headers"
            :items="items"
  :items-per-page.sync="options.itemsPerPage"
:footer-props="footer"
            :loading="isLoading"
            :loading-text="$t('global.loading')"
            :options.sync="options"
            :server-items-length="totalItems"
            class="elevation-1"
            item-key="@id"
            @update:options="onUpdateOptions"
            @click:row="showHandler"
@contextmenu:row="showHandlerExt"
          >
                <template slot="item.number" slot-scope="{ item }">
                  {{ $n(item['number']) }}
                </template>
                <template slot="item.type" slot-scope="{ item }">
                  <ul>
                    <li v-for="_item in item['type']" :key="_item">
                      {{ _item }}
                    </li>
                  </ul>
                </template>
                <template slot="item.valueType" slot-scope="{ item }">
                  <ul>
                    <li v-for="_item in item['valueType']" :key="_item.id">
                      {{ _item.name }}
                    </li>
                  </ul>
                </template>


            <ActionCell
              slot="item.action"
              slot-scope="props"
              :handle-show="() => showHandler(props.item)"
            ></ActionCell>
          </v-data-table>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { mapFields } from 'vuex-map-fields';
import ListMixin from '../../mixins/ListMixin';
import ActionCell from '../../components/ActionCell';
import QualityCheckTestFilterForm from '../../components/qualitychecktest/Filter';
import DataFilter from '../../components/DataFilter';
import Toolbar from '../../components/Toolbar';
import AccessMixin from '../../mixins/AccessMixin';

export default {
  name: 'QualityCheckTestList',
  servicePrefix: 'QualityCheckTest',
  mixins: [ListMixin,AccessMixin],
  components: {
    Toolbar,
    ActionCell,
    QualityCheckTestFilterForm,
    DataFilter
  },
  data() {
    return {
      headers: [
        { text: this.$t('qualitycheck.test.number'), value: 'number' },
        { text: this.$t('qualitycheck.test.name'), value: 'name' },
        { text: this.$t('qualitycheck.test.namefr'), value: 'namefr' },
        { text: this.$t('qualitycheck.test.issue'), value: 'issue' },
        { text: this.$t('qualitycheck.test.type'), value: 'type' },
        { text: this.$t('qualitycheck.test.typevalue'), value: 'valueType' },
        {
          text: this.$t('global.actions'),
          value: 'action',
          sortable: false
        }
      ],
      selected: [],
footer: {
  'itemsPerPageText': "",
},
      options: {sortBy : ['name'], sortDesc : [false]}
    };
  },
  computed: {
    ...mapGetters('qualitychecktest', {
      items: 'list'
    }),
    ...mapFields('qualitychecktest', {
      deletedItem: 'deleted',
      error: 'error',
      isLoading: 'isLoading',
      resetList: 'resetList',
      totalItems: 'totalItems',
      view: 'view'
    })
  },
  methods: {
    ...mapActions('qualitychecktest', {
      getPage: 'fetchAll',
      deleteItem: 'del'
    })
  }
};
</script>
